export default __webpack_public_path__ + "static/media/talk-to-me.a88b6b21.png";